//import datasList from './datasList.json';
import datas from './categorieProduitsXylophage.json';
import categories from './categories.json';

export default class DevisService {
    getAll(critere) {
        /*if (critere != null) {
            var retour = [];
            datasList.map(data => {
                if (data.numero.toString().includes(critere) || data.nom.toLowerCase().includes(critere.toLowerCase())) {
                    retour.push(data);
                }
                return data;
            });
            return retour;
        } else {
            return datasList;
        }*/
        return null;
    }

    getById(id) {
        var retour = null;
        if (id === 1 || id === 2 || id === 3) {
            retour = datas;
        }
        return retour;
    }

    getCategories() {
        return categories;
    }
}


// WEBPACK FOOTER //
// ./src/services/devis/DevisService.js